import React, { Component, PropTypes } from 'react';
import SingleSection from './single-section';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import DateUtils from '../../../../utils/date-utils';
import SeasonErrors from '../season-errors';
import AskIfVaryBySeason from './ask-if-vary-by-season';
import { call, compose, addIndex, equals, curry, not, append, remove, insert, pathOr, nthArg, pick, always, ifElse, map, merge, prop, chain, propOr, isEmpty, reject, isNil, complement, all, omit, and } from 'ramda';
const notNil = complement(isNil);
const singlePluralMap = {
  allocations: 'allocation information',
  'cancellation policies': 'cancellation policy',
  'pickup information': 'pickup information',
  'dropoff information': 'dropoff information',
};
class SeasonSection extends Component {
  constructor(props) {
    super(props);
    const { varyBySeason, useSeasons } = props;
    this.state = { varyBySeason, useSeasons };
  }
  populateInitialContent = () => {
    const { varyBySeason, useSeasons } = this.state;
    const { emptyInitialContent, onFieldChange, seasons, contractingPeriod } = this.props;
    const addDatesIfUseSeasons = compose(merge(emptyInitialContent), pick(['dateRanges']));
    const addDatesIfNotUseSeasons = ifElse(
      equals(true),
        always({ dateRanges: [{}] }),
      always({ dateRanges: [{ seasonStartDate: contractingPeriod.startDate, seasonEndDate: contractingPeriod.endDate }] })
    );
    const initialContentWithDates = call(ifElse(
      equals(true),
        () => map(addDatesIfUseSeasons, seasons),
      () => [merge(emptyInitialContent, addDatesIfNotUseSeasons(varyBySeason))]
    ), useSeasons);
    onFieldChange([], initialContentWithDates);
  }
  selectIfVaryBySeason = value => {
    this.setState({ varyBySeason: value, useSeasons: value || false }, this.populateInitialContent);
    if (this.props.onVaryBySeasonChange) this.props.onVaryBySeasonChange(value);
  }
  selectIfUseSeasons = value => this.setState({ useSeasons: value }, this.populateInitialContent);
  render() {
    const {
      name,
      enableManualDatesEntry,
      contractingPeriod,
      emptyInitialContent,
      onFieldChange,
      contentActions,
      contentsData,
      ContentNode,
      seasons,
      showError,
    } = this.props;
    const { varyBySeason, useSeasons } = this.state;
    const { startDate, endDate } = contractingPeriod || {};
    const onChangeDate = curry((index, dateIndex, dateField, value) => onFieldChange([index, 'dateRanges', dateIndex, dateField], value));
    const dateRangeActions = {
      onChangeDate,
      removeADateRange: curry((index, dateIndex) => onFieldChange([index, 'dateRanges'], call(compose(
        remove(dateIndex, 1),
        pathOr([], [index, 'dateRanges'])
      ), contentsData))),
      addADateRange: curry((index, dateIndex) => onFieldChange([index, 'dateRanges'], call(compose(
        insert(dateIndex + 1, {}),
        pathOr([], [index, 'dateRanges'])
      ), contentsData))),
    };
    const userMadeSelection = all(notNil, [varyBySeason, useSeasons]);
    const datesEditable = and(not(useSeasons), varyBySeason);
    const allDateRanges = DateUtils.getFlattenedUnEmptyDates(contentsData);
    const contractingPeriodCovered = DateUtils.checkIfFullSeasonCoveredForAProduct(startDate, endDate, allDateRanges);
    const allDateRangesFromSeasons = DateUtils.getFlattenedUnEmptyDates(seasons);
    const seasonDoNotCoverContractingPeriod = DateUtils.checkIfFullSeasonCoveredForAProduct(startDate, endDate, allDateRangesFromSeasons) > 0;
    const isSingleSeason = allDateRangesFromSeasons
      && allDateRangesFromSeasons.length === 1
      && allDateRangesFromSeasons[0].seasonStartDate === new Date(contractingPeriod.startDate).toISOString()
      && allDateRangesFromSeasons[0].seasonEndDate === new Date(contractingPeriod.endDate).toISOString();

    return (
      <div>
        {
          !isSingleSeason || enableManualDatesEntry ? (
            <AskIfVaryBySeason
              enableManualDatesEntry={enableManualDatesEntry}
              name={name}
              varyBySeason={varyBySeason}
              useSeasons={useSeasons}
              selectIfVaryBySeason={this.selectIfVaryBySeason}
              selectIfUseSeasons={this.selectIfUseSeasons}
            />
          ) : <span/>
        }
        <br/>
        <div style={{ textAlign: 'center', color: '#f44336' }}>
          {
            useSeasons && isEmpty(seasons) ? `You don't have seasons created yet.` : ''
          }
          {
            useSeasons && !isEmpty(seasons) && seasonDoNotCoverContractingPeriod ? `Please make sure you have season dates for the entire contracting period.` : ''
          }
        </div>
        <div
          style={{
            display: (() => {
              if (isSingleSeason) return 'block';
              return !userMadeSelection || (useSeasons && !(seasons && seasons.length)) ? 'none' : 'block';
            })(),
          }}
        >
          <div
            style={{
              paddingLeft: '32px',
              paddingRight: '32px',
              marginBottom: '12px',
              display: varyBySeason && !useSeasons ? 'block' : 'none',
            }}
          >
            <SeasonErrors
              startDate={startDate}
              endDate={endDate}
              seasonDateRanges={allDateRanges}
            />
          </div>
          {
            isSingleSeason ? <div/> : (
              <TwoColumnRow
                outerContainerStyle={{ paddingLeft: '32px', marginBottom: '14px' }}
                leftColumnStyle={{ width: '20%', fontSize: '12px' }}
                rightColumnStyle={{ width: '80%'}}
                leftColumnContent="Dates"
                rightColumnContent=""
              />
            )
          }
          <div style={{ minHeight: '100px' }}>
            {
              contentsData.map((contentData, index) => (
                <SingleSection
                  key={index}
                  index={index}
                  seasons={seasons}
                  datesEditable={datesEditable}
                  contractingPeriod={contractingPeriod}
                  ContentNode={ContentNode}
                  showError={showError}
                  removeOneSeasonSet={() => onFieldChange([], remove(index, 1, contentsData))}
                  useCorrectSeason={() => onFieldChange([index], call(compose(
                    omit(['correctSeasonName', 'correctDateRanges']),
                    dateRanges => merge(contentData, { dateRanges }),
                    prop('correctDateRanges')
                  ), contentData))}
                  dateRangeActions={dateRangeActions}
                  contentActions={contentActions}
                  takenDateRanges={call(compose(
                    DateUtils.transformDateRanges,
                    chain(propOr([], 'dateRanges')),
                    addIndex(reject)(compose(equals(index), nthArg(1)))
                    ), contentsData
                  )}
                  {...contentData}
                />
              ))
            }
            <div
              style={{
                display: datesEditable && contractingPeriodCovered > 0 ? 'block' : 'none',
                borderBottom: '1px solid #ededed',
                borderTop: '1px solid #ededed',
                backgroundColor: '#fafafa',
                height: '62px',
                lineHeight: '62px',
                textAlign: 'center',
                color: '#21c4d8',
                cursor: 'pointer',
              }}
              onClick={() => onFieldChange([], append(merge(emptyInitialContent, { dateRanges: [{}] }), contentsData))}
            >
              + Add more {name}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SeasonSection.propTypes = {
  name: PropTypes.string,
  contractingPeriod: PropTypes.object,
  removeOneSeasonSet: PropTypes.func,
  addOneSeasonSet: PropTypes.func,
  emptyInitialContent: PropTypes.object,
  onFieldChange: PropTypes.func,
  contentActions: PropTypes.object,
  contentsData: PropTypes.array,
  ContentNode: PropTypes.any,
  seasons: PropTypes.array,
  enableManualDatesEntry: PropTypes.bool,
  onVaryBySeasonChange: PropTypes.func,
  showError: PropTypes.bool,
};

export default SeasonSection;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/seasonal-sections/seasonal-sections.jsx